import React from "react";
import { Link } from "react-router-dom";
import { CheckCircle2, ArrowRight } from "lucide-react";

/**
 * Generic informational / launchpad panel used for app-style sections
 * (AI Visibility, Comfort App, Marketing App).
 */
export default function InfoPanel({ icon: Icon, title, subtitle, points = [], actions = [] }) {
  return (
    <div data-testid="info-panel">
      <div className="flex items-center gap-2 mb-1">
        {Icon && <Icon className="w-6 h-6 text-cool" />}
        <h1 className="text-2xl font-bold text-navy">{title}</h1>
      </div>
      <p className="text-slate-500 mb-6 max-w-2xl">{subtitle}</p>

      <div className="grid lg:grid-cols-2 gap-6">
        <div className="bg-white rounded-xl border border-slate-200 p-6">
          <h2 className="font-bold text-navy mb-4">What this does</h2>
          <ul className="space-y-3">
            {points.map((p, i) => (
              <li key={i} className="flex gap-3 text-sm text-slate-600">
                <CheckCircle2 className="w-5 h-5 text-launch flex-shrink-0 mt-0.5" />
                <span>{p}</span>
              </li>
            ))}
          </ul>
        </div>
        <div className="bg-navy text-white rounded-xl p-6 dot-grid flex flex-col justify-center">
          <h2 className="font-bold text-lg">Quick links</h2>
          <p className="text-slate-300 text-sm mt-1 mb-4">Jump straight to the tools that power this.</p>
          <div className="space-y-2">
            {actions.map((a, i) => (
              a.to ? (
                <Link key={i} to={a.to} className="flex items-center justify-between bg-white/10 hover:bg-white/15 rounded-lg px-4 py-3 text-sm font-semibold transition-colors">
                  {a.label} <ArrowRight className="w-4 h-4 text-launch" />
                </Link>
              ) : (
                <a key={i} href={a.href} target="_blank" rel="noreferrer" className="flex items-center justify-between bg-white/10 hover:bg-white/15 rounded-lg px-4 py-3 text-sm font-semibold transition-colors">
                  {a.label} <ArrowRight className="w-4 h-4 text-launch" />
                </a>
              )
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
